const DEBUG_MODE = true;
// "NET" or "VAT"
const VAT_MODE = "NET";
// Remmebr to update free shipping banner and shipping costs on cart page
const FREE_SHIPPING_TOTAL = 150;
const TIER_FIVE_LIMIT = 350;
const TIER_SEVENPOINTFIVE_LIMIT = 1000;
const TIER_TEN_LIMIT = 1500;
let isHandlingError = false;


const formatFinance = (number) =>
  new Intl.NumberFormat("en-UK", {
    style: "currency",
    currency: "GBP",
  }).format(number);
  
  const showShippingNotice = () => {
    DEBUG_MODE && console.log("show ship fired");
    const fst = FREE_SHIPPING_TOTAL;
    const sc = document.getElementById("free-shipping-notice");
    sc.innerHTML = ``;    
    
    const pt = document.getElementById("price-tier-notice");
    const li = pt.getAttribute("data-iacali") ?? "true";
  const wv = pt.getAttribute("data-page") ?? "false";
  pt.innerHTML = ``;

  const np = document.getElementById("totalCartWithPrice");
  const pe = document.querySelector(".csapps-cart-total");
  const po = document.querySelector(".csapps-cart-original-total");
  const p =
    VAT_MODE === "NET"
      ? pe.innerText.length >= 1
        ? justNumbers(pe.innerText)
        : justNumbers(po.innerText)
      : justNumbers(np.innerText);

  const tier =
    p <= TIER_FIVE_LIMIT
      ? TIER_FIVE_LIMIT
      : p <= TIER_SEVENPOINTFIVE_LIMIT
      ? TIER_SEVENPOINTFIVE_LIMIT
      : TIER_TEN_LIMIT;

  const fin = formatFinance(fst - p);
  const finT = formatFinance(tier - p);

  if (p < fst) {
    let pg = (p / fst) * 100;
    sc.innerHTML = `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center">Spend<strong id="shippingPrice"> ${fin} </strong>more for <strong>free shipping</strong>!</div><div class="free-shipping-notice__bar mt-3" style="--progress: ${
      pg < fst ? pg : 100
    }%" id="free-shipping-notice__bar"></div></div></div>`;
    sc.style.transform = "scaleY(1)";
  } else {
    sc.innerHTML = `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="20000"><div class="free-shipping-notice__heading mb-2 text-center"><strong id="shippingPrice">Your order is eligible for free shipping!</strong></div><div class="free-shipping-notice__bar mt-3" style="--progress: 100%" id="free-shipping-notice__bar"></div></div></div>`;
    sc.style.transform = "scaleY(1)";
  }

  tier <= 350 ? "" : "" ? "" : "";

  if (pt) {
    DEBUG_MODE && console.log("price tier notice fired", pt, p, p < TIER_TEN_LIMIT);    
    if (p < TIER_TEN_LIMIT) {
      let prg = (p / tier) * 100;            
      
      const msg = tier <= 350
      ? li === "false"
      ? ``
      : `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center">You are<strong id="shippingPrice"> ${finT} </strong>away from our <strong>5%</strong> discount tier!</div><div class="free-shipping-notice__bar mt-3" style="--progress: ${prg}%" id="free-shipping-notice__bar"></div></div></div>`
      : tier <= 1000
      ? li === "false"
      ? `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center">Logged in customers would get <strong>5%</strong> off this order...${
        wv === "side-cart" ? "<br />" : " "
        }<strong><a href="https://www.atlasflowers.co.uk/account/register" style="text-decoration:underline">Join Atlas Flowers</a></strong></div></div>`
        : `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center"><strong>5% discount added...</strong> spend<strong id="shippingPrice"> ${finT} </strong>more to reach our <strong>7.5%</strong> discount tier!</div><div class="free-shipping-notice__bar mt-3" style="--progress: ${prg}%" id="free-shipping-notice__bar"></div></div></div>`
        : li === "false"
        ? `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center">Logged in customers would get <strong>7.5%</strong> off this order...${
          wv === "side-cart" ? "<br />" : " "
          }<strong><a href="https://www.atlasflowers.co.uk/account/register" style="text-decoration:underline">Join Atlas Flowers</a></strong></div></div>`
          : `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center"><strong>7.5% discount added...</strong> spend<strong id="shippingPrice"> ${finT} </strong>more to reach our <strong>10%</strong> discount tier!</div><div class="free-shipping-notice__bar mt-3" style="--progress: ${prg}%" id="free-shipping-notice__bar"></div></div></div>`;
          
          DEBUG_MODE && console.log("Checking -", 
            tier <= 350, li === "false", "\n", "MSG -", msg)

      pt.innerHTML = msg
      
    } else {
      pt.innerHTML = `<div class="free-shipping-container color-scheme color-scheme--1" id="free-shipping-int"><div class="block mx-auto text-theme-heading" data-minimum="15000"><div class="free-shipping-notice__heading mb-2 text-center"><strong id="shippingPrice">You've qualified for 10% order discount!</strong></div><div class="free-shipping-notice__bar mt-3" style="--progress: 100%" id="free-shipping-notice__bar"></div></div></div>`;      
      DEBUG_MODE && console.log("show ship finished");
    }
  }
};

const fadeOut = (el, time) => {
  let opac = 1;
  const fade = setInterval(() => {
    opac = opac - 0.1;
    el.style.opacity = opac;
  }, 50);
  setTimeout(() => {
    clearInterval(fade);
  }, time);
};

setErrorMessage = (error) => {
  if (error.includes("You can't")) {
    const trimEnd = error.replace(" to the cart.", "");
    const trimStart = trimEnd.replace("You can't add more ", "");
    const errorBox = document.querySelectorAll(`[data-product-name=${'"' + trimStart + '"'}]`);
    errorBox.forEach((eb) => {
      eb.removeAttribute("hidden");
      eb.style.opacity = 1;
      eb.style.position = "absolute";
    });
  } else {
    const errorBox = document.getElementById(error);
    errorBox.removeAttribute("hidden");
    errorBox.innerText = `You can't add more ${errorBox.dataset.productName} to the cart`;
    errorBox.style.opacity = 1;
    errorBox.style.position = "absolute";
  }
};

const getLnsCont = () => {
  return document.getElementById("cart-items").querySelector(".cart_wrapper");
};

const justNumbers = (inputString) =>
  typeof inputString === "string" ? inputString.replace(/[^0-9\.]+/g, "") : inputString;
const getNet = (gross) => (parseFloat(gross) / 6) * 5;

const waitForElementToExist = (selector) => {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    const observerOptions = {
      childList: true,
      subtree: true,
    };

    observer.observe(document.body, observerOptions);
  });
};

const writePrice = (el, price) => {
  el.style.fontWeight = 700;
  el.innerText = formatFinance(price);
};

const showEachPrice = (cartLines) => {
  cartLines.forEach((cartLine) => {
    console.log("cartLineS", cartLine);
    writePrice(cartLine.unitPrice, justNumbers(cartLine.subtotal.innerText) / cartLine.qty);
  });
};

const getCartLines = (cartLinesContainer) => {
  // const allLines = [...cartLinesContainer.querySelectorAll('[id*="cart-item"]')];
  const allLines = [...document.querySelectorAll('[id*="cart-item-"]')];

  const cartLines = allLines.map((line) => {
    const getCartLineUnitPriceElement = () =>
      [...line.children].map((line) => line.querySelector("#lineUnitPrice")).filter((i) => i)[0];

    let subtotalelem;
    const qty = parseInt(line.querySelector("input").value);

    const productLine = line.querySelector('[id*="product_"]');
    console.log("GET SPANES", productLine);
    if (productLine.firstChild.className === "money") {
      subtotalelem = productLine.firstChild;
    } else {
      const getSpans = [...productLine.getElementsByTagName("span")];
      const getSubtotal = getSpans.find((span) => span.classList.contains("cs_final_price"));
      if (getSubtotal) {
        subtotalelem = getSubtotal;

        const subtotal = subtotalelem;
        const subtotalAmount = subtotalelem ? subtotalelem.innerText : "";
        const subtotalAmountIncTax = subtotalelem
          ? formatFinance(justNumbers(subtotalelem.innerText) * 1.2)
          : undefined;
        const unitPrice = getCartLineUnitPriceElement();

        return {
          line: line.id,
          qty: qty,
          unitPrice,
          subtotal,
          subtotalAmount,
          subtotalAmountIncTax,
          taxStatus: line.querySelector('[id*="product_t"]') ? "Inc VAT" : "Exc VAT",
        };
      } else {
        subtotalelem = getSpans.find((span) => span.classList.contains("price__current"));

        // let subtotalAmount = justNumbers(subtotalelem.innerText) * qty;
        // subtotalelem.innerText = subtotalelem ? formatFinance(justNumbers(subtotalelem.innerText) * qty) : "";

         const raw = justNumbers(subtotalelem.innerText);

      // only multiply once
          if (!subtotalelem.dataset.isSubtotal) {
          subtotalAmount = raw * qty;
          subtotalelem.innerText = formatFinance(subtotalAmount);
          subtotalelem.dataset.isSubtotal = "true";
        } else {
        subtotalAmount = raw;
        }







        const subtotalAmountIncTax = subtotalelem ? formatFinance(subtotalAmount * 1.2) : undefined;
        subtotalelem.style.fontWeight = 700;
        const subtotal = subtotalelem;
        const unitPrice = getCartLineUnitPriceElement();
        subtotalAmount = formatFinance(subtotalAmount);

        return {
          line: line.id,
          qty: qty,
          unitPrice,
          subtotal,
          subtotalAmount,
          subtotalAmountIncTax,
          taxStatus: line.querySelector('[id*="product_t"]') ? "Inc VAT" : "Exc VAT",
        };
      }
    }
  });
  return cartLines;
};

const removeLoading = () => {
  const allLinePrices = [...document.getElementsByClassName("cart-price-container")];
  const cartTotalContainer = document.getElementById("cartTotalContainer");
  const drawerTotalContainer = document.getElementById("drawer-total-container");
  cartTotalContainer && allLinePrices.push(cartTotalContainer);
  drawerTotalContainer && allLinePrices.push(drawerTotalContainer);
  allLinePrices.forEach((elem) => (elem.style.opacity = 1));
  // remove spinner
  const loadingSpinner = document.querySelector(".cart-item__loader");
  loadingSpinner.setAttribute("hidden", false);
};

const createTaxLines = (containerElement, grossPrice) => {
  const createMoneySpanTotal = document.createElement("span");
  const showIncTax = document.createElement("span");
  createMoneySpanTotal.id = "totalCartWithPrice";
  createMoneySpanTotal.className = "money";
  createMoneySpanTotal.innerText = formatFinance(grossPrice);
  createMoneySpanTotal.style.fontSize = "16px !important";
  showIncTax.appendChild(createMoneySpanTotal);
  showIncTax.className = "show-cart-total-inc";
  containerElement.appendChild(showIncTax);
};

const returnTotalCart = () => {
  const cartPriceContainer = document.getElementById("totalCartPrice");
  const twda = cartPriceContainer.querySelector(".csapps-cart-total");
  const twoda = cartPriceContainer.querySelector(".csapps-cart-original-total");

  if (!!twda) {
    return twda.innerText;
  } else if (!!twoda) {
    const twodap = twoda.innerText;
    const addPrice = document.createElement("span");
    addPrice.innerHTML = `<span class="csapps-cart-total"><span class="money">${twodap}</span></span>`;
    twoda.parentElement.appendChild(addPrice);
    return twodap;
  } else {
    DEBUG_MODE && console.log("Error getting total");
  }
};

const setSpinner = () => {
  const loadingSpinner = document.querySelector(".cart-item__loader");
  loadingSpinner.setAttribute("hidden", false);

  setTimeout(() => {
    const isEmpty = () => document.getElementById("cart-drawer-form").querySelectorAll(".cart-empty").length >= 1;
    DEBUG_MODE &&
      console.log("isEmpty", isEmpty(), document.getElementById("cart-drawer-form").querySelectorAll(".cart-empty"));

    if (isEmpty()) {
      const pt = document.getElementById("price-tier-notice");
      pt.innerHTML = "";
      loadingSpinner.setAttribute("hidden", true);
    } else {
      DEBUG_MODE && console.log("Spinner fired", loadingSpinner.hidden, loadingSpinner);
      if (loadingSpinner.hidden) {
        DEBUG_MODE && console.log("Removing loading spinner...");
        loadingSpinner.setAttribute("hidden", true);
      } else {
        DEBUG_MODE && console.log("Showing Loading spinner...");
        loadingSpinner.setAttribute("hidden", false);
      }
    }
  }, 1000);
};

const cartTotalChanges = () => {
  const addedLines = document.getElementById("totalCart");
  const taxLine = document.getElementById("totalTax");
  const cartPrice = returnTotalCart();
  const cartTotalNetPrice = justNumbers(cartPrice);
  const cartTotalGrossPrice = justNumbers(cartPrice) * 1.2;
  
  // Clean up any existing duplicates first
  const existingExSpans = addedLines.querySelectorAll('.show-cart-total-ex');
  if (existingExSpans.length > 1) {
    for (let i = 1; i < existingExSpans.length; i++) {
      existingExSpans[i].remove();
    }
  }
  
  const existingIncSpans = addedLines.querySelectorAll('.show-cart-total-inc');
  if (existingIncSpans.length > 1) {
    for (let i = 1; i < existingIncSpans.length; i++) {
      existingIncSpans[i].remove();
    }
  }
  
  // Check if ex VAT span already exists, if so update it, otherwise create it
  let exVatSpan = addedLines.querySelector('.show-cart-total-ex');
  if (exVatSpan) {
    const moneySpan = exVatSpan.querySelector('.money');
    if (moneySpan) {
      moneySpan.innerHTML = cartPrice;
    }
  } else {
    const newElem = document.createElement("span");
    newElem.innerHTML = `<span class="money">${cartPrice}</span>`;
    newElem.className = "show-cart-total-ex";
    addedLines.insertBefore(newElem, addedLines.children[0]);
  }

  // Check if inc VAT span already exists, if so update it, otherwise create it
  let incVatContainer = addedLines.querySelector(".show-cart-total-inc");
  if (incVatContainer) {
    const totalIncVat = incVatContainer.querySelector("#totalCartWithPrice");
    if (totalIncVat) {
      totalIncVat.innerText = formatFinance(cartTotalGrossPrice);
    }
  } else {
    createTaxLines(addedLines, cartTotalGrossPrice);
  }
  
  if (taxLine) {
    taxLine.innerText = formatFinance(cartTotalGrossPrice - cartTotalNetPrice);
  }
};

const reloadPrices = (ce) => {
  showEachPrice(ce);
  ce.forEach((c) => {
    const lineId = document.getElementById(c.line);
    const linePrice = lineId.querySelector("#lineUnitPrice");
    linePrice.innerText = c.unitPrice.innerText;
  });
  cartTotalChanges();
  
  // Clean up duplicates AFTER cartTotalChanges creates them
  setTimeout(() => {
    cleanupDuplicateSubtotals();
  }, 50);
  
  removeLoading();
  showShippingNotice();
  DEBUG_MODE && console.log("reload prices finished", ce);
};

const showNetPrice = (itemsChanged) => {
  const containerElem = getLnsCont();
  let cartLines = [{}];
  cartLines = getCartLines(containerElem);
  DEBUG_MODE && cartLines.forEach((cartLine) => console.log(`Line ${cartLine.line}`, cartLine.unitPrice.innerText));

  if (itemsChanged === "add") {
    DEBUG_MODE && console.log("add fired");
    const checkForNewLines = async () => {
      DEBUG_MODE && console.log("check new lines fired");

      fetch("/cart.js", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      })
        .then((response) => {
          response
            .json()
            .then((i) => {
              const res = i;
              DEBUG_MODE && console.log("cart:", res);
              if (cartLines.length !== res.items.length) {
                let ce = getCartLines(getLnsCont());
                reloadPrices(ce);
                setTimeout(() => {
                  let ce = getCartLines(getLnsCont());
                  reloadPrices(ce);
                }, 1500);
              }
            })
            .catch((e) => DEBUG_MODE && console.log("Error:", e));
        })
        .catch((error) => console.error(error));
    };
    checkForNewLines();
  } else if (itemsChanged === "change") {
    DEBUG_MODE && console.log("change fired");
    let ce = getCartLines(getLnsCont());
    reloadPrices(ce);
  } else {
    // Remove the "error" case entirely - it's now handled by the on:cart:error event listener
    reloadPrices(cartLines);
  }

  setSpinner(false);
  DEBUG_MODE && cartLines.forEach((cartLine) => console.log(`Line ${cartLine.line}`, cartLine.unitPrice.innerText));
};

document.addEventListener("DOMContentLoaded", () => {
  const cartItems = document.querySelectorAll("cart-items");
  setSpinner();
  cartItems.forEach((cart) => {
    if (!!cart.cartDrawer) {
      DEBUG_MODE && console.log("Looking for element in cart drawer");
      waitForElementToExist(".csapp-price-wrapper").then(() => showNetPrice());
    } else {
      DEBUG_MODE && console.log("Looking for element in cart");
      waitForElementToExist(".csapp-price-wrapper").then(() => showNetPrice());
    }
  });

  document.addEventListener("on:line-item:change", (e) => {
  DEBUG_MODE && console.log("changed", e);
  
  // Don't handle change events while we're handling an error
  if (isHandlingError) {
    DEBUG_MODE && console.log("Ignoring change event during error handling");
    return;
  }
  
  setSpinner();
  waitForElementToExist(".csapp-price-wrapper").then(() => showNetPrice("change"));
});

  // Track add or remove items
  // track add/remove event listener/trigger
  document.addEventListener("on:cart:add", (e) => {
    DEBUG_MODE && console.log("Added", e);
    setSpinner();
    waitForElementToExist(".csapp-price-wrapper").then(() => showNetPrice("add"));
  });
});

const cleanupDuplicateSubtotals = () => {
  console.log("Cleaning up duplicate subtotals...");
  
  // Find cart total containers that might have duplicates
  const totalCart = document.getElementById("totalCart");
  
  if (totalCart) {
    // Remove duplicate "show-cart-total-ex" spans (keep only the first one)
    const exSpans = totalCart.querySelectorAll('.show-cart-total-ex');
    if (exSpans.length > 1) {
      console.log(`Found ${exSpans.length} ex VAT spans, removing duplicates...`);
      for (let i = 1; i < exSpans.length; i++) {
        exSpans[i].remove();
      }
    }
    
    // Remove duplicate "show-cart-total-inc" spans (keep only the first one)
    const incSpans = totalCart.querySelectorAll('.show-cart-total-inc');
    if (incSpans.length > 1) {
      console.log(`Found ${incSpans.length} inc VAT spans, removing duplicates...`);
      for (let i = 1; i < incSpans.length; i++) {
        incSpans[i].remove();
      }
    }
  }
  
  // Also check each line item for duplicate subtotals
  const allLines = document.querySelectorAll('[id*="cart-item-"]');
  allLines.forEach(line => {
    const productLine = line.querySelector('[id*="product_"]');
    if (productLine) {
      // Find the "real" subtotal span - it should have either price__current or cs_final_price class
      const realSubtotal = productLine.querySelector('.price__current') 
        || productLine.querySelector('.cs_final_price');
      
      if (realSubtotal) {
        // Get all money spans
        const allMoneySpans = productLine.querySelectorAll('.money');
        
        if (allMoneySpans.length > 1) {
          console.log(`Found ${allMoneySpans.length} money spans in line, removing duplicates...`);
          
          // Remove any money spans that are NOT the real subtotal
          allMoneySpans.forEach(span => {
            // Don't remove if it's the real subtotal or inside the real subtotal
            if (span !== realSubtotal && !realSubtotal.contains(span)) {
              console.log("Removing duplicate span:", span.innerText);
              span.remove();
            }
          });
        }
      }
    }
  });
  
  console.log("Cleanup complete");
};

document.addEventListener("on:cart:error", (err) => {
  console.log("cart error event fired:", err);
  
  // Detect if we're on the cart page or in the cart drawer
  const isCartPage = window.location.pathname.includes('/cart');
  
  console.log(`Error on ${isCartPage ? 'cart page' : 'cart drawer'}`);
  
  // Show error message first
  try {
    if (err.detail && err.detail.error) {
      setErrorMessage(err.detail.error);
      
      // Keep error visible and make it dismissible
      const errors = document.querySelectorAll('[id*="line-item-error"]');
      errors.forEach((error) => {
        if (error) {
          error.removeAttribute("hidden");
          error.style.opacity = 1;
          error.style.position = "absolute";
          error.style.cursor = "pointer";
          error.title = "Click to dismiss";
          
          const dismissHandler = () => {
            fadeOut(error, 500);
            setTimeout(() => {
              error.setAttribute("hidden", true);
            }, 500);
            error.removeEventListener('click', dismissHandler);
          };
          
          error.addEventListener('click', dismissHandler);
        }
      });
    }
  } catch (e) {
    console.log("Error setting error message:", e);
  }
  
  // Reload based on context
  console.log("Reloading to refresh prices and quantities...");
  
  setTimeout(() => {
    if (isCartPage) {
      console.log("Reloading cart page...");
      window.location.reload();
    } else {
      console.log("Reloading cart drawer...");
      fetch(window.location.href + '?section_id=cart-drawer')
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCartDrawer = doc.querySelector('cart-drawer');
          const currentCartDrawer = document.querySelector('cart-drawer');
          
          if (newCartDrawer && currentCartDrawer) {
            currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
            console.log("Cart drawer refreshed successfully");
            
            setTimeout(() => {
              waitForElementToExist(".csapp-price-wrapper").then(() => showNetPrice());
            }, 500);
          }
        })
        .catch(error => {
          console.error("Error refreshing cart drawer:", error);
          window.location.reload();
        });
    }
  }, 300);
});